<template>
    <div class="search-results-item flex-container">
        <div class="search-results-item-img">
            <img v-if="info.thumbnail_field && result[info.thumbnail_field]" :src="result[info.thumbnail_field]" alt="" />
            <img src="/static/img/placeholder-158-158.png" alt="" v-else />
        </div>
        <div class="search-results-item-content">
            <div v-for="(field, i) in info.fields" :key="`field-${i}`" :class="{small: (info.big_fields || [0, 3]).indexOf(i) === -1}">
                <router-link v-if="routerLink && i === 0" :to="routerLink" @click.native.stop="$emit('close')">
                    {{ getValue(field) }}
                </router-link>
                <span v-else>{{ getValue(field) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TypeParamMixin } from '@/mixins/TypeParamMixin'; 

const { mapGetters } = createNamespacedHelpers('bmr');

export default {
    mixins: [TypeParamMixin],
    props: ['result', 'resultType'],
    data () {
        return {
            resultTypeInfo: {
                'contacts': {
                    'fields': ['full_name', 'title', 'email', 'phone'],
                    'thumbnail_field': 'photo_url'
                },
                'news_articles': {
                    'fields': ['title', result => this.formatDate(result.publication_date), 'short_description'],
                    'router': ['NewsDetail', 'slug', 'slug'],
                    'thumbnail_field': 'thumbnail_image_url',
                },
                'activities': {
                    'fields': ['name', result => this.formatDate(result.date), 'short_description'],
                    'router': ['ActivityDetail', 'slug', 'slug']
                },
                'notices': {
                    'big_fields': [0, 1],
                    'fields': [
                        'title',
                        result => this.getPageTypeInfo(result.type).name,
                        result => this.formatDate(result.publication_date)
                    ],
                    'router': result => {
                        let pageType = this.getPageTypeInfo(result.type);
                        let params = { slug: result.slug, type: pageType.route_params.type ? pageType.route_params.type : null };

                        return {
                            name: pageType.route_name === 'PriceChangeList' ? this.localizedRoute(pageType.route_name) : this.localizedRoute('NoticeDetail'),
                            params: params
                        };
                    }
                },
                'bookings': {
                    'big_fields': [0],
                    'fields': [
                        'name',
                        result => this.bookingDateRangeValue(result),
                        result => this.$gettextInterpolate(this.$ngettext('%{ count } linked product', '%{ count } linked products', result.product_lines.length), { count: result.product_lines.length }),
                        result => this.$gettextInterpolate(this.$ngettext('%{ count } linked notice', '%{ count } linked notices', result.notices.length), { count: result.notices.length }),
                    ],
                    'router': ['BookingDetail', 'slug', 'slug']
                },
                'pages': {
                    'big_fields': [0, 1],
                    'fields': [
                        'title',
                        result => this.getPageTypeInfo(result.type.slug).name,
                        result => this.formatDate(result.publication_date),
                        'short_description',
                    ],
                    'router': result => {
                        return {
                            name: this.localizedRoute('StaticDetail'),
                            params: { slug: result.slug, type: this.getPageTypeInfo(result.type.slug).slug }
                        };
                    }
                }
            }
        };
    },
    computed: {
        ...mapGetters(['allPages']),
        info () {
            return this.resultTypeInfo[this.resultType];
        },
        routerLink () {
            if (!this.info.router) {
                return null;
            }

            if (typeof this.info.router === 'function') {
                return this.info.router(this.result);
            }

            return {
                name: this.localizedRoute(this.info.router[0]),
                params: {
                    [this.info.router[1]]: this.result[this.info.router[2]]
                }
            };
        }
    },
    methods: {
        getValue (field) {
            if (typeof field === 'function') {
                return field(this.result);
            }
            return this.result[field];
        },
        formatDate (date) {
            return this.$options.filters.formatDate(date);
        },
        bookingDateRangeValue (result) {
            return this.$gettextInterpolate(
                this.$gettext('From %{ start } to %{ end }'),
                { start: this.formatDate(result.start_date), end: this.formatDate(result.end_date) }
            );
        },
    }
};
</script>

<style lang="scss" scoped>
.search-results-item {
    padding: 1em 0;
    border-top: 1px solid transparentize($color-alto, 0.8);
    &:last-child {
        border-bottom: 1px solid transparentize($color-alto, 0.8);
    }
}
.search-results-item-img {
    padding-right: 1em;
    flex-shrink: 0;
    img {
        height: 64px;
    }
}
.search-results-item-content {
    font-weight: 700;
}
.small {
    @include rem-typo(13px);
    color: $color-dimgray;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/SearchResult.vue